import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function B2BHomepage() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const categories = [
    {
      name: "Voyages",
      description: "Ajoutez ou gérez les voyages touristiques organisés.",
      icon: "fa-plane",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      path: "/b2bVoyage",
    },
    {
      name: "Sport dans le monde",
      description: "Ajoutez les événements sportifs internationaux.",
      icon: "fa-futbol",
      gradient: "linear-gradient(135deg, #93f7fbff 0%, #403179ff 100%)",
      path: "/b2bSport",
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #2b276aff 0%, #4c1c87ff 50%, #2d1b4bff 100%)",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated Background Pattern */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          opacity: 0.1,
          background: `
            radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(221, 214, 254, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 40% 20%, rgba(167, 139, 250, 0.3) 0%, transparent 50%)
          `,
          pointerEvents: "none",
        }}
      ></div>

      {/* Header */}
      <header
        style={{
          position: "relative",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(20px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <div
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            padding: "1rem 1.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      
              <img
                src="/assets/img/logo1.png"
                alt="Aviator Logo"
                style={{ width: "60px", height: "80" }}
              />
          
            <h2
              style={{
                margin: 0,
                fontSize: "20px",
                fontWeight: "700",
          
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Aviator B2B Dashboard
            </h2>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "8px 16px",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "9999px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
              }}
            >
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  background: "linear-gradient(135deg, #a78bfa 0%, #ec4899 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fa fa-user" style={{ color: "#fff", fontSize: "14px" }}></i>
              </div>
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                {user?.name || user?.email}
              </span>
            </div>

            <button
              onClick={handleLogout}
              style={{
                padding: "10px 20px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "8px",
                color: "#fff",
                fontWeight: "600",
                cursor: "pointer",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                e.target.style.transform = "scale(1)";
              }}
            >
              <i className="fa fa-sign-out" style={{ marginRight: "8px" }}></i>
              Déconnexion
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main
        style={{
          position: "relative",
          maxWidth: "1280px",
          margin: "0 auto",
          padding: "4rem 1.5rem",
        }}
      >
        {/* Hero Section */}
        <div style={{ textAlign: "center", marginBottom: "4rem" }}>
          <div
            style={{
              display: "inline-block",
              marginBottom: "1rem",
              padding: "6px 16px",
              backgroundColor: "rgba(130, 3, 249, 0.2)",
              border: "1px solid rgba(76, 4, 143, 0.3)",
              borderRadius: "9999px",
              color: "#b4b7feff",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            <i className="fa fa-sparkles" style={{ marginRight: "8px" }}></i>
            Tableau de bord - Aviator Travel B2B
          </div>
          <h1
            style={{
              fontSize: "48px",
              fontWeight: "700",
              marginBottom: "1rem",
              background: "linear-gradient(90deg, #fff 0%, #e9d5ff 50%, #fbcfe8 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Gestion des Événements
          </h1>
          <p
            style={{
              color: "#9ca3af",
              fontSize: "18px",
              maxWidth: "672px",
              margin: "0 auto",
            }}
          >
            Gérez facilement vos voyages et événements sportifs en quelques clics
          </p>
        </div>

   

        {/* Category Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "32px",
          }}
        >
          {categories.map((cat, index) => (
            <div
              key={index}
              style={{
                position: "relative",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                backdropFilter: "blur(20px)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                borderRadius: "24px",
                padding: "32px",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
              onClick={() => navigate(cat.path)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
                const overlay = e.currentTarget.querySelector(".gradient-overlay");
                if (overlay) overlay.style.opacity = "1";
                const glow = e.currentTarget.querySelector(".glow-effect");
                if (glow) glow.style.opacity = "1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
                const overlay = e.currentTarget.querySelector(".gradient-overlay");
                if (overlay) overlay.style.opacity = "0";
                const glow = e.currentTarget.querySelector(".glow-effect");
                if (glow) glow.style.opacity = "0";
              }}
            >
              {/* Gradient Overlay */}
              <div
                className="gradient-overlay"
                style={{
                  position: "absolute",
                  inset: 0,
                  background: cat.gradient,
                  opacity: 0,
                  transition: "opacity 0.5s ease",
                }}
              ></div>

              {/* Glow Effect */}
              <div
                className="glow-effect"
                style={{
                  position: "absolute",
                  top: "-96px",
                  right: "-96px",
                  width: "192px",
                  height: "192px",
                  background: "rgba(168, 85, 247, 0.3)",
                  borderRadius: "50%",
                  filter: "blur(60px)",
                  opacity: 0,
                  transition: "all 0.5s ease",
                }}
              ></div>

              {/* Content */}
              <div style={{ position: "relative", zIndex: 10 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      background: "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                      backdropFilter: "blur(10px)",
                      borderRadius: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <i className={`fa ${cat.icon}`} style={{ fontSize: "28px" }}></i>
                  </div>

                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      backdropFilter: "blur(10px)",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                  >
                    <i className="fa fa-arrow-right"></i>
                  </div>
                </div>

                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    marginBottom: "12px",
                  }}
                >
                  {cat.name}
                </h3>
                <p
                  style={{
                    color: "#d1d5db",
                    marginBottom: "24px",
                    lineHeight: "1.6",
                  }}
                >
                  {cat.description}
                </p>

                <button
                  style={{
                    width: "100%",
                    padding: "12px 24px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    borderRadius: "12px",
                    color: "#fff",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(cat.path);
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.color = "#1f2937";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                    e.target.style.color = "#fff";
                  }}
                >
                  Gérer les événements
                  <i className="fa fa-arrow-right" style={{ marginLeft: "8px" }}></i>
                </button>
              </div>

              {/* Corner Decoration */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "128px",
                  height: "128px",
                  background: "linear-gradient(to bottom left, rgba(255,255,255,0.05), transparent)",
                  borderBottomLeftRadius: "100%",
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div
          style={{
            marginTop: "3rem",
            background: "linear-gradient(90deg, rgba(168, 85, 247, 0.1) 0%, rgba(236, 72, 153, 0.1) 100%)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRadius: "16px",
            padding: "32px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: window.innerWidth < 768 ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "24px",
            }}
          >
            <div>
              <h3 style={{ fontSize: "20px", fontWeight: "700", marginBottom: "8px", color: "#fff" }}>
                Besoin d'aide ?
              </h3>
              <p style={{ color: "#9ca3af", margin: 0 }}>
                 N'hesitez pas à nous contacter.
              </p>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <button
                style={{
                  padding: "12px 24px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "12px",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                }}
              >
                <i className="fa fa-question-circle" style={{ marginRight: "8px" }}></i>
               manager@aviatortravel.tn
              </button>
              <button
                style={{
                  padding: "12px 24px",
                  background: "linear-gradient(90deg, #a855f7 0%, #ec4899 100%)",
                  border: "none",
                  borderRadius: "12px",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                }}
              >
                <i className="fa fa-phone" style={{ marginRight: "8px" }}></i>
                29308000
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer
        style={{
          position: "relative",
          marginTop: "5rem",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          padding: "2rem 0",
        }}
      >
        <div
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            padding: "0 1.5rem",
            textAlign: "center",
            color: "#9ca3af",
            fontSize: "14px",
          }}
        >
          <p style={{ margin: 0 }}> Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
}

export default B2BHomepage;